import React, { Component } from 'react';
import { observer } from "mobx-react"

import { Formik, Form, Field, ErrorMessage, useFormikContext } from 'formik';

import ValidateTimesheet from "../../util/validation/StudentTimesheet";
import { StudentSubmitTimesheet } from "../../store/wrappers/ServiceObjects/StudentSubmitTimesheet";
import Timesheet from "../../store/wrappers/Timesheet";

import PayPeriodTable from "./PayPeriodTable";
import { NextStepsPanel } from "../student/widgets/PrintTimesheetPanel";

import moment from 'moment';
import queryString from 'query-string';

import TimesheetSubmissionButton from "./widgets/TimesheetSubmissionButton";



class TimesheetSubmissionForm extends Component {

    static displayName = TimesheetSubmissionForm.name;

    constructor(props) {
        super(props);

        //Get the params from the URL 
        let params = queryString.parse(props.location.search);

        let endDay = params["endDay"];
        let accountId = parseInt(params["accountId"]);


        const account = this.props.store.accounts.getById(accountId)
        //Should check to ensure it returns valid response

        this.account = account.include(["student", "employer", "supervisor", "timesheet", "timestamp"]);
        const latestStatus =
            this.account.accountStatusChanges &&
                this.account.accountStatusChanges.length > 0
                ? this.account.accountStatusChanges[this.account.accountStatusChanges.length - 1]
                : null;

        this.isLocked = latestStatus && latestStatus.status === "Locked";
        this.lockNote = latestStatus ? latestStatus.note : null;
        let timesheet = this.getTimesheet(endDay)
        let timestamps = StudentSubmitTimesheet.generateTimestamps(timesheet, endDay, this.props.store);
        console.log(timestamps)

        //Decide which view to use intially.
        let isAdmin = this.props.store.user.isAdmin;
        let displayMode = "confirm";
        if (!timesheet || (isAdmin && !timesheet.isCertified)) {
            displayMode = "mutate"
        }

        this.state = {
            endDay: endDay,
            accountId: accountId,
            timesheet: timesheet,
            timestamps: timestamps,
            mode: displayMode,
            isSubmitting: false
        };


        //Bind button click event functions ;
        this.handleChangeMode = this.handleChangeMode.bind(this);
        this.handleFinalSubmission = this.handleFinalSubmission.bind(this);
        this.handleSubmission = this.handleSubmission.bind(this);
    }


    getTimesheet(endDay) {
        //Search to see if this pay period already exists for this account. If so, we're editting.

        let timesheets = this.props.store.timesheets.collection;
        timesheets = timesheets.filter((timesheet) => {
            //Use moment object for easier date comparison
            let payPeriodObject = moment(endDay)

            //Check if there are any timesheets for this day  
            if (timesheet.weekEndDateObject.isSame(payPeriodObject, "day")) {
                //confirm they match this student's account ID (just a double-check)

                if (timesheet.accountId == this.account.id) {
                    return true
                }
                return false;
            }
        });

        if (timesheets.length > 0) {
            return timesheets[0];
        }
        else {
            return false;
        }

    }

    // Sorry, I know this is awkward.
    // We essentially set all the timestamp fields to a blank default.
    // E.g. {SaturdayIn = "", SaturdayOut = ""} and so on.
    // You can adjust the values for ease of testing with the format hh:mm, 24-hour time.  
    setInitialValues() {
        const initialValues = {};

        if (this.state.timesheet == false) {
            for (const day of this.state.timestamps) {
                let dayName = day.dayName;
                initialValues[(dayName + "In")] = "";
                initialValues[(dayName + "Out")] = "";
                initialValues[(dayName + "LunchIn")] = "";
                initialValues[(dayName + "LunchOut")] = "";
            }
        }
        else {
            //Set the initial values to that which is in the timesheet 
            for (const day of this.state.timestamps) {
                let dayName = day.dayName;
                initialValues[(dayName + "In")] = day.inObject ? day.hourDisplay(day.in) : "";
                initialValues[(dayName + "Out")] = day.outObject ? day.hourDisplay(day.out) : "";
                initialValues[(dayName + "LunchIn")] = day.lunchInObject ? day.hourDisplay(day.lunchIn) : "";
                initialValues[(dayName + "LunchOut")] = day.lunchOutObject ? day.hourDisplay(day.lunchOut) : "";
            }
        }

        return initialValues;
    }

    //Gets triggered if a button with 'submit' is pressed. 
    async handleSubmission(values, setSubmitting) {

        this.setState({ isSubmitting: true });

        console.log(values);
        const submissions = [];
        for (const day of this.state.timestamps) {

            const In = values[(day.dayName + "In")] ? moment(values[(day.dayName + "In")], "HH:mm") : null;
            const Out = values[(day.dayName + "Out")] ? moment(values[(day.dayName + "Out")], "HH:mm") : null;
            const LunchIn = values[(day.dayName + "LunchIn")] ? moment(values[(day.dayName + "LunchIn")], "HH:mm") : null;
            const LunchOut = values[(day.dayName + "LunchOut")] ? moment(values[(day.dayName + "LunchOut")], "HH:mm") : null;

            //Convert add the hours and minutes to the days date, and convert them to ISO format (without changing timezone).
            //Momentjs objects are mutable, so we clone it first. 
            submissions.push({
                in: values[(day.dayName + "In")],
                out: values[(day.dayName + "Out")],
                lunchIn: values[(day.dayName + "LunchIn")],
                lunchOut: values[(day.dayName + "LunchOut")]
            });
        }


        //Construct object to match StudentSubmissionDTO   
        const submissionObject = {
            "accountId": this.state.accountId,
            "endDay": moment(this.state.endDay).startOf("day").toISOString(true),
            "timestamps": submissions
        }

        console.log(submissionObject)

        let serviceObject = new StudentSubmitTimesheet(submissionObject);

        //Send submission to API. 
        let response = await serviceObject.save(this.props.store);

        if (!response.errors) {
            let timesheet = this.getTimesheet(this.state.endDay);
            let timestamps = StudentSubmitTimesheet.generateTimestamps(timesheet, this.state.endDay, this.props.store);


            let isAdmin = this.props.store.user.isAdmin;
            //Admins don't need a confirmation view. 
            let displayMode = "confirm";
            if (isAdmin && timesheet.isCertified == false) {
                displayMode = "mutate"
            }

            this.setState({
                timesheet: response,
                timestamps: timestamps,
                mode: displayMode
            });
        }

        await this.props.store.getFromApi(["timesheets", "timestamps", "accounts"])

        this.setState({ isSubmitting: false });
    }


    render() {
        return (
            <div>
                {this.introText()}
                <div className="panel panel-default">
                    {this.panelHead()}

                    <div className="panel-body">
                        <Formik
                            initialValues={this.setInitialValues()}
                            validate={values => ValidateTimesheet(values)}
                            onSubmit={(values, { setSubmitting }) => this.handleSubmission(values, setSubmitting)}
                        >
                            {({ isSubmitting }) => (
                                <Form>
                                    {this.isLocked && (
                                        <div className="alert alert-danger mb-3">
                                            <strong>This account is locked.</strong>
                                            {this.lockNote && <div>Note: {this.lockNote}</div>}
                                        </div>
                                    )}
                                    <table aria-label="Submit timesheet form">

                                        {this.tableHeader()}

                                        <PayPeriodTable
                                            mode={this.state.mode}
                                            startDate={this.account.endDate}
                                            endDate={this.account.startDate}
                                            days={this.state.timestamps}
                                            holidays={this.props.store.holidays.collection}
                                        />

                                        {this.tableFooter()}

                                    </table>

                                    <div className="submissionButtons">
                                        <TimesheetSubmissionButton store={this.props.store}
                                            timesheetId={this.state.timesheet.id} mode={this.state.mode}
                                            handleChangeMode={this.handleChangeMode}
                                            handleFinalSubmission={this.handleFinalSubmission}
                                            isSubmitting={this.state.isSubmitting}

                                        />
                                    </div>

                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        )
    }

    introText() {
        if (this.state.mode == "confirm" && this.state.timesheet) {
            //Initial timesheet has been submitted 
            return null;
        }
        //We are in edit mode  
        else {
            return (
                <p className="h3 mb-2">Edit Timesheet</p>
            )
        }
    }

    panelHead() {
        const student = this.props.store.students.getById(this.account.studentId);
        return (
            <div className="panel-heading d-flex">
                <div className="col-md-6" style={{ paddingLeft: "5em" }}>
                    <p><strong>Timesheet for:</strong> {student ? student.name : ""}</p>
                    <p><strong>For week:</strong> {moment(this.state.endDay).clone().subtract(6, "days").format("MM/DD/YYYY")} - {moment(this.state.endDay).format("MM/DD/YYYY")}</p>
                    <p><strong>Student ID:</strong> {this.account.student.tuid}</p>
                </div>
                <div className="col-md-6" style={{ paddingLeft: "5em" }}>
                    <p><strong>Department:</strong> {this.account.employer.name}</p>
                    <p><strong>Supervisor(s):</strong> {this.account.supervisor.name}</p>
                    <p><strong>Award Amount:</strong> ${this.account.student.awardAmount.toFixed(2)}</p>
                </div>
            </div>
        )
    }

    tableHeader() {
        return (
            <thead>
                <tr>
                    <th className="pad-right text-center" scope="col">Day</th>
                    <th className="pad-left text-center" scope="col">Start Time</th>
                    <th className="pad-right text-center" scope="col">End Time</th>
                    <th className="pad-left text-center" scope="col">Lunch Start</th>
                    <th className="pad-right text-center" scope="col">Lunch End</th>
                    <th className="pad-left text-nowrap text-center" scope="col">Paid Hours</th>
                </tr>
            </thead>
        );
    }

    tableFooter(props) {
        return (
            <tfoot>
                <tr>
                    <td colSpan="4">

                    </td>
                    <td className="text-nowrap"><strong>{this.state.mode == "confirm" && this.state.timesheet ? "Week Total: $" + this.state.timesheet.totalPay.toFixed(2) : ""}</strong></td>
                    <td className="text-nowrap">
                        <strong>{this.state.mode == "confirm" && this.state.timesheet ? this.state.timesheet.totalHours.toFixed(2) + " Hours" : ""}</strong>
                    </td>
                </tr>
            </tfoot>
        );
    }

    async handleFinalSubmission(event) {
        event.preventDefault();
        this.setState({ isSubmitting: true });

        //Confirm with user that they'd like to submit their timesheet, even though it can't be editted afterwards?
        if (window.confirm("Would you like to submit your timesheet? Please carefully review the hours and make sure that they are accurate. Once you sign the timesheet, the system will automatically forward the timesheet to your Employer/Supervisor for approval and signature. PLEASE RECHECK YOUR TIME BEFORE SUBMITTING YOUR TIMESHEET. Timesheets that require revision may result in a delay in payment.")) {

            const submission = JSON.parse(JSON.stringify(this.state.timesheet));
            console.log(submission);
            submission.isFinal = "true"

            console.log(this.state.timesheet)
            console.log(submission)

            let timesheet = new Timesheet(submission, true);

            let submitObject = new StudentSubmitTimesheet()

            console.log(timesheet);

            let response = await submitObject.save(this.props.store, timesheet.id);


            if (response.errors == null) {
                this.setState({
                    timesheet: timesheet
                });

            }
        }

        await this.props.store.getFromApi(["timesheets", "timestamps", "accounts"])


        this.setState({ isSubmitting: false });
    }

    handleChangeMode(event) {
        event.preventDefault();

        if (this.state.mode == "confirm") {
            this.setState({ mode: "mutate" })
        }
        if (this.state.mode == "mutate") {
            this.setState({ mode: "confirm" })
        }
    }

}


export default observer(TimesheetSubmissionForm);